<template>
  <div class="tender-emitter-information" v-if="emitter">
    <div class="tender-emitter-information__content">
      <div class="title">{{ $t('tender-details.emitter-information') }}</div>

      <div v-if="emitter.name" class="tender-emitter-information__name">
        <div class="subtitle">{{ $t('tender-details.emitter-informations.organization') }}</div>
        <div class="tender-emitter-information__value">{{ emitter.name }}</div>
      </div>

      <div v-if="emitter.website" class="tender-emitter-information__website">
        <div class="subtitle">{{ $t('tender-details.emitter-informations.website') }}</div>
        <a :href="emitter.website" target="blank">{{ emitter.website }}</a>
      </div>

      <div v-if="displayAddress" class="tender-emitter-information__address">
        <div class="subtitle">{{ $t('tender-details.emitter-informations.address') }}</div>
        <div class="tender-emitter-information__value">{{ displayAddress }}</div>
      </div>

      <div v-if="emitter.contactPoints && emitter.contactPoints.length">
        <div class="subtitle">{{ $t('tender-details.emitter-informations.contacts.contacts') }}</div>
        <div
          v-for="(contactPoint, index) in emitter.contactPoints"
          :key="index"
          class="tender-emitter-information__contact"
        >
          <div
            v-if="contactPoint.name"
            class="tender-emitter-information__value tender-emitter-information__contact-name"
          >
            {{ contactPoint.name }}
          </div>
          <div
            v-if="contactPoint.telephone"
            class="tender-emitter-information__value tender-emitter-information__contact-phone"
          >
            {{ contactPoint.telephone }}
          </div>
          <div
            v-if="contactPoint.faxNumber"
            class="tender-emitter-information__value tender-emitter-information__contact-fax"
          >
            {{ contactPoint.faxNumber }}
          </div>
          <div
            v-if="contactPoint.email"
            class="tender-emitter-information__value tender-emitter-information__contact-email"
          >
            <a :href="`mailto:${contactPoint.email}`">{{ contactPoint.email }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDeliveryLocation } from '@/util/delivery-location-display';

export default {
  name: 'TenderEmitterInformation',
  props: {
    emitter: {
      default: () => {},
      type: Object,
      required: false,
    },
  },
  computed: {
    displayAddress() {
      const address = this.emitter && this.emitter.address;
      if (!address) return null;
      if (typeof address === 'string') return address.trim() || null;

      const value = (field) => (typeof field === 'string' ? field.trim() : '');
      const street = value(address.streetAddress);
      const locality = value(address.locality);
      const postalCode = value(address.postalCode);
      const raw = value(address.raw);
      const structured = formatDeliveryLocation(
        { ...address, raw: null },
        (key) => this.$t(key),
        (key) => this.$te && this.$te(key),
      );

      if (street && (locality || postalCode)) return structured;
      if (raw) return raw;
      return street || locality || postalCode || value(address.area) || value(address.region) ? structured : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.tender-emitter-information {
  display: flex;
  flex: 1 auto;
  width: 100%;

  &__content {
    max-width: 100%;
    width: 100%;
  }

  a {
    border-bottom: $green-border;
    color: $color-accent;
    text-decoration: none;
    font-size: $font-size-small;
    line-height: 1.43;
  }

  &__value {
    color: $color-normal-pale;
    font-size: $font-size-small;
    line-height: 1.43;
    list-style-type: none;
    word-break: break-word;
  }

  &__name,
  &__website,
  &__address {
    width: 100%;
    word-break: break-word;
  }

  &__contact {
    padding: 4px 8px;
    margin-bottom: 8px;
    background-color: $color-neutral-pale;

    &-email {
      padding-bottom: 4px;
    }
  }
}
</style>
